export default "__VITE_ASSET__BX64A6k1__"